// extracted by mini-css-extract-plugin
module.exports = {"nest":"LegalPage-module__nest___118lb","legalPage":"LegalPage-module__legalPage___2WcxL","title":"LegalPage-module__title___2DLJn","anchor":"LegalPage-module__anchor___3WlRn"};